module.exports = __webpack_public_path__ + "static/media/headset.295ea6ce.svg";